import React from "react";
import Login from "../components/login/Login";
import Header from "../components/Header";

function LoginPage() {
  return (
    <>
      <Header />
      <Login />
    </>
  );
}

export default LoginPage;
